import { render, staticRenderFns } from "./LearningSuite.vue?vue&type=template&id=a42bd8cc&scoped=true"
import script from "./LearningSuite.vue?vue&type=script&lang=js"
export * from "./LearningSuite.vue?vue&type=script&lang=js"
import style0 from "./LearningSuite.vue?vue&type=style&index=0&id=a42bd8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42bd8cc",
  null
  
)

export default component.exports